import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    login: 'Log in',
    online: 'online',
  },
  ru: {
    login: 'Войти',
    online: 'online',
  },
  uz: {
    login: 'Kirish',
    online: 'online',
  },
  fa: {
    login: 'ورود',
    online: 'آنلاین',
  },
});
